const _ = require("lodash");
const TestResultManager = require("./test");

const getStars = function(result) {
	return 0;
};

// Returns the summary view to use and any data to pass to it.
const getSummaryInfo = function(result) {
	return {
		viewType: "bookTest",
		data: {
			problemsSolvedText: getSummaryProblemsSolvedText(result),
		},
	};
};

const getStarProgressInfo = function(result) {
	return TestResultManager.getStarProgressInfo(result);
};

const isFinished = function(result) {
	const anyUnansweredProblems = _.some(result.problems, p => !p.outcome);
	return result.testComplete || result.isComplete || !anyUnansweredProblems;
};

const computeBackendProgress = function(result, defaultProgress) {
	return TestResultManager.computeBackendProgress(result, defaultProgress);
};

const shouldIntervene = function(result) {
	return false;
};

const getFirstAvailableIndex = function(result) {
	return TestResultManager.getFirstAvailableIndex(result);
};

const getLastAvailableIndex = function(result) {
	return TestResultManager.getLastAvailableIndex(result);
};

const getSetProgressInfo = function(result) {
	return TestResultManager.getSetProgressInfo(result);
};

const getPercentComplete = function(result) {
	return TestResultManager.getPercentComplete(result);
};

const getSummaryProblemsSolvedText = function(result) {
	return TestResultManager.getSummaryProblemsSolvedText(result);
};

const settings = {
	saveAllProblems: true,
	allowBrowseOnSummary: true,
	updatePercentCompleteOnStateChange: true,
	starProgressType: "test",
	canSwitchSet: true,
	staticMaxStars: true,
};

module.exports = {
	shouldIntervene,
	computeBackendProgress,
	getFirstAvailableIndex,
	getSummaryInfo,
	getLastAvailableIndex,
	getSetProgressInfo,
	getPercentComplete,
	getStarProgressInfo,
	isFinished,
	getStars,
	getSummaryProblemsSolvedText,
	settings,
};
